<script>
// import * as THREE from 'three';
import { reactive, toRefs, ref, computed, render, onUpdated, mounted } from 'vue'
import mapThree from './components/threejs/index.vue'

export default {
  data() {

    return {
      title: 'Hello, World!',//这里面放一些注册变量
 
    };
  },
  render() {
    return this.$scopedSlots.default({
     
    });
  },
  methods: {
    Three() {
      //vue方法

    }
  },
  mounted() {
    // 组件渲染完成后执行的代码vue2.0
    // console.log('组件加载完成钩子');
  },

  components: {
    mapThree//本地注册组件
  }

};

</script>

<template>
  <div id="app">

    <!-- <HelloWorld msg="Welcome to r .js App"/> -->
    <mapThree></mapThree>
 
  </div>
</template>



<style>
#app {
padding: 0px;
}
</style>
